<script setup lang="ts">
import type { AnnotationCollectionItem } from '@nuxt/content'

const props = defineProps<{
  source: AnnotationCollectionItem
}>()
</script>

<template>
  <div class="flex gap-2 items-center">
    <h4 class="mr-4 flex size-6 shrink-0 items-center justify-center rounded-full border border-secondary-100 bg-secondary-50 text-sm font-bold text-secondary-600">
      {{ props.source.title }}
    </h4>
    <ContentRenderer :value="props.source" class="prose-sm" />
  </div>
</template>
